// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Saga for Excel Export and Comment Lines
// MODIFIED DATE: 18-09-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';

import DemandFollowupActionTypes from './demand-followup-report.types';

import { demandFollowupListGet } from './demand-followup-report.service';

import {
	getDemandFollowupDetailsSuccess,
	getDemandFollowupDetailsFailure,
	getDemandFollowupDetailsResponseChanged,
} from './demand-followup-report.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET DEMAND FOLLOWUP REPORT DETAILS  ******************** */
export function* getDemandFollowupList({ payload }: any) {
	try {
		const { companyID, branchID, databaseName, month, year, loanType } = payload;
		const key = 'DemandFollowupKey';
		const jsonData = {
			companyID: companyID,
			Branch: branchID,
			DatabaseName: databaseName,
			Month: month,
			Year: year,
			LoanIndexType: loanType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(demandFollowupListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDemandFollowupDetailsFailure(responseData.data));
		} else {
			yield put(getDemandFollowupDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDemandFollowupDetailsFailure(error));
	}
}

export function* resetGetDemandFollowupListResponse() {
	yield put(getDemandFollowupDetailsResponseChanged());
}

export function* onGetDemandFollowupListDetails() {
	yield takeLatest(
		DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_START,
		getDemandFollowupList,
	);
}

export function* onGetDemandFollowupListResponseReset() {
	yield takeLatest(
		DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_RESPONSE_RESET,
		resetGetDemandFollowupListResponse,
	);
}
/** *********************  END GET DEMAND FOLLOWUP REPORT DETAILS ******************** */

export function* reportDemandFollowupSaga() {
	yield all([call(onGetDemandFollowupListDetails), call(onGetDemandFollowupListResponseReset)]);
}
